
//Représente les données d’un item de la barre de navigation
export class ValBarreNavigationItem 
{
  //Création
  constructor ()
  {
    this.dico = null;
    this.libelle = "";
    this.ouvert = false;
    this.masque = false;
    this.selectionne = false;
    this.commandes = [];
   }

  //Dico
  public dico?: string | null;

  //Classe css de l’icone
  public iconeClass?: string;

  //Libellé
  public libelle?: string;

  //Indique si ouvert
  public ouvert?: boolean;

  //Indique si masqué
  public masque?: boolean;

  //Indique si sélecionné
  public selectionne?: boolean;

  //Commandes associées
  public commandes?: ValBarreNavigationItem[];

  //Commande de navigation
  public navigationCommande?: any[];
}
